import { Typography } from '@mui/material';
import React from 'react';
import I18n, { useI18n } from '../../../common/i18n/I18n';
import { LabelValueDisplay } from '../../../attributes/AttributeValue';
import { PUNCTUATION_MARKS_CONSTANTS } from '../../../common/constants/constants';
import { H } from '../../../common/Layout';
import { Person } from 'sr-types/lib/search/v1/graphql';
import { Contact } from 'sr-types/lib/production/v1/graphql';
import { PERSON_DEFAULT_VALUES } from '../../../person/utils/personConstants';
import { EntityOption } from '../../../common/form/forms';

export type PersonOptionType = Omit<Contact, 'name'> &
    EntityOption & {
        //for ReferenceAutocomplete name must be string
        name: string;
    };

export default ({ option }) => {
    const createOption = option?.createOption;
    const label = createOption ? (
        <I18n token={`form.button.add.value`} values={{ inputValue: option.label }} />
    ) : (
        option.label
    );

    const noEmailText = useI18n('common.no.email.text');
    const email = option?.contactInfo?.email?.address ?? noEmailText;
    const organizationInfo = [option?.role].filter(Boolean).join(`${PUNCTUATION_MARKS_CONSTANTS.comma} `);
    const productionInfo = [option?.productionRole].filter(Boolean).join(` ${PUNCTUATION_MARKS_CONSTANTS.comma} `);
    const subLabel = [email, organizationInfo, productionInfo]
        .filter(Boolean)
        .join(` ${PUNCTUATION_MARKS_CONSTANTS.pipe} `);

    return (
        <H gap={1}>
            {createOption ? (
                <Typography sx={{ fontStyle: createOption ? 'italic' : 'normal' }}>{label}</Typography>
            ) : (
                <LabelValueDisplay label={subLabel} value={option.name} labelOnTop={false} />
            )}
        </H>
    );
};

export const getProductionPersonOption = (item: Person): PersonOptionType => {
    const contactInfo = {
        ...item.contactInfo,
        ...(item.contactInfo?.email && {
            email: {
                ...item.contactInfo.email,
                address: item.contactInfo.email.address ?? '',
                typeString: item.contactInfo.email.typeString ?? PERSON_DEFAULT_VALUES.typeString,
                verified: item.contactInfo.email.verified ?? false
            }
        }),
        ...(item.contactInfo?.phone && {
            phone: {
                ...item.contactInfo.phone,
                number: item.contactInfo.phone.number ?? '',
                typeString: item.contactInfo.phone.typeString ?? PERSON_DEFAULT_VALUES.typeString
            }
        })
    };
    return {
        //Contact fields
        id: item.id,
        name: item.name,
        label: item.name,
        organizationDepartment: item.department,
        productionRoles: item.productionRole ? [item.productionRole] : [],
        roles: item.role ? [item.role] : [],
        personReference: item.reference,
        contactInfo
    };
};
